import React, { useMemo } from 'react';

import { useAppDispatch, useAppSelector } from '../../../../hooks/react-redux';
import { getAvailableDocumentNames } from '../../../admin/documents/store';
import { WizardTab } from '../../../shared/wizard/WizardTab';
import styles from '../Reports.module.scss';
import { getSelectedAgreementTypeId, setSelectedAgreementTypeId } from '../store';

interface AgreementTypeTabsProps {
    reportAgreementTypeIds: number[];
}

export const AgreementTypeTabs: React.FC<AgreementTypeTabsProps> = ({ reportAgreementTypeIds }) => {
    const dispatch = useAppDispatch();
    const selectedAgreementTypeId = useAppSelector(getSelectedAgreementTypeId);
    const allDocumentNames = useAppSelector(getAvailableDocumentNames);

    const agreementTypes = useMemo(() => reportAgreementTypeIds.map(agreementTypeId => {
        const label = allDocumentNames.find(documentName => documentName.agreementTypeId === agreementTypeId)?.agreementType || '';
        return { agreementTypeId, label, selected: selectedAgreementTypeId === agreementTypeId };
    }), [reportAgreementTypeIds, allDocumentNames, selectedAgreementTypeId]);

    const tabs = useMemo(() => agreementTypes.map(({ agreementTypeId, label, selected }) => ({
        label,
        selected,
        onClick: () => dispatch(setSelectedAgreementTypeId(agreementTypeId))
    })), [agreementTypes, dispatch]);

    return (
        <>
            {tabs.length > 1 && <div className={styles.agreementTypeTabWrapper}>
                {tabs.map(({ label, onClick, selected }) => (
                    <WizardTab key={label} label={label} onClick={onClick} selected={selected} />
                ))}
            </div>}
        </>
    );
};
